import React from "react";
import Table from "react-bootstrap/Table";
import "./DetaljiTable.css";
import { PaperClipOutlined, ZoomInOutlined } from "@ant-design/icons";
import ButtonComponent from "../UI/ButtonComponent/ButtonComponent";
import RazlogBrisanjaComponent from "./RazlogBrisanjaComponent";

const ovlRevizorDetaljiTable = (props) => {
  let drustvo;
  let adresaDrustva = [];
  let registracijaDrustva = [];
  let kontaktDrustva = [];
  let osobaDrustvo = [];
  let mjere = [];

  let odobrenjeZaRad = [];
  let registracijaUDrugojDrzavi = [];
  let registracijaZaTreceZemlje = [];
  let tijeloNadleznoZaNadzor = [];

  let adresa = [];
  let adresaUreda = [];

  let registar = props.children;

  drustvo = registar[1];
  adresaDrustva = registar[2];
  registracijaDrustva = registar[3];
  kontaktDrustva = registar[4];
  osobaDrustvo = registar[5];
  mjere = registar[7];

  adresa = adresaDrustva.filter((x) => x.vrAdr == 1)[0];

  adresaUreda = adresaDrustva.filter((x) => x.vrAdr == 2);

  odobrenjeZaRad = registracijaDrustva.filter(
    (x) => x.vrRegistracije == 1 && x.sifDrzave == 191
  );

  registracijaUDrugojDrzavi = registracijaDrustva.filter(
    (x) => x.vrRegistracije == 2
  );

  registracijaZaTreceZemlje = registracijaDrustva.filter(
    (x) => x.vrRegistracije == 3
  );

  tijeloNadleznoZaNadzor = registracijaDrustva.filter(
    (x) => x.vrRegistracije == 4
  );

  const noDataMessage = "";

  const { userRole } = props;

  const checkIfUserIsAdmin =
    userRole === "ROLE_REFERENT" || userRole === "ROLE_SLUZBENIK";

  return (
    <div id="printArea">
      {drustvo.napomena ? (
        <RazlogBrisanjaComponent razlog={drustvo.napomena} />
      ) : null}
      <h5>Pregled podataka</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Samostalni revizor</th>
            <th scope="col">OIB</th>
            <th scope="col">Registarski broj</th>
            {checkIfUserIsAdmin ? <th scope="col">Matični broj</th> : null}
            <th scope="col">Broj i datum odobrenja za rad</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {drustvo.ime} {drustvo.prezime}
            </td>
            <td x-ms-format-detection="none">{drustvo.oib}</td>
            <td>{drustvo.regBroj}</td>
            {checkIfUserIsAdmin ? (
              <td>{drustvo.mbr ? drustvo.mbr : noDataMessage}</td>
            ) : null}
            <td className="hr-divider">
              {odobrenjeZaRad.map((element) => (
                <>
                  <table>
                    {!element.brReg && !element.datReg ? (
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Izdavatelj: </b>
                            Hrvatska revizorska komora
                          </td>
                        </tr>
                      </tbody>
                    ) : (
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Broj odobrenja za rad: </b>
                            {element.brReg}
                          </td>
                        </tr>
                        <tr>
                          <td className="inner-td">
                            <b>Datum odobrenja za rad: </b>
                            {element.datReg}
                          </td>
                        </tr>
                      </tbody>
                    )}
                  </table>
                  <hr />{" "}
                </>
              ))}
            </td>
          </tr>
        </tbody>
      </Table>

      <h5>Adrese</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Adresa sjedišta</th>
            <th scope="col">Adresa svakog ureda</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <table>
                <tbody>
                  <tr>
                    <td className="inner-td">
                      <b>Ulica i kbr: </b>
                      {adresa.ulicaKbr ? adresa.ulicaKbr : noDataMessage}
                    </td>
                  </tr>
                  {adresa.brPoste || adresa.nazNaselja ? (
                    <tr>
                      <td className="inner-td">
                        <b>Grad: </b>
                        {adresa.brPoste}
                        {adresa.nazNaselja && " " + adresa.nazNaselja}
                      </td>
                    </tr>
                  ) : null}

                  {adresa.drzava ? (
                    <tr>
                      <td className="inner-td">
                        <b>Država: </b>
                        {adresa.drzava}
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            </td>
            <td className="hr-divider">
              {adresaUreda.length > 0
                ? adresaUreda.map((adrUred, index) => (
                  <>
                    {adrUred.ulicaKbr
                      &&
                      (
                        adrUred.brPoste
                        ||
                        adrUred.nazNaselja
                      )
                      &&
                      adrUred.drzava
                      ?
                      (
                        <>
                          <table key={`adresa-ureda${index}`}>
                            <tbody>
                              <tr>
                                <td className="inner-td">
                                  <b>Ulica i kbr: </b>
                                  {adrUred.ulicaKbr
                                    ? adrUred.ulicaKbr
                                    : noDataMessage}
                                </td>
                              </tr>
                              {adrUred.brPoste || adrUred.nazNaselja ? (
                                <tr>
                                  <td className="inner-td">
                                    <b>Grad: </b>
                                    {adrUred.brPoste}
                                    {adrUred.nazNaselja && " " + adrUred.nazNaselja}
                                  </td>
                                </tr>
                              ) : null}
                              {adrUred.drzava ? (
                                <tr>
                                  <td className="inner-td">
                                    <b>Država: </b>
                                    {adrUred.drzava}
                                  </td>
                                </tr>
                              ) : null}
                            </tbody>
                          </table>
                          <hr />
                        </>
                      ) : null
                    }
                  </>
                  ))
                : noDataMessage}
            </td>
          </tr>
        </tbody>
      </Table>

      <h5>Kontakt podaci</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Kontakt</th>
          </tr>
        </thead>
        <tbody>
          {kontaktDrustva.length > 0 ? (
            kontaktDrustva.map((kontaktDrustvo, index) =>
              !kontaktDrustvo.ime &&
              !kontaktDrustvo.prezime &&
              !kontaktDrustvo.telefon &&
              !kontaktDrustvo.web &&
              !kontaktDrustvo.email ? (
                <tr key={`kontakt-drustva`}>
                  <td></td>
                </tr>
              ) : (
                <tr key={`trkontakt${index}`}>
                  <td x-ms-format-detection="none">
                    <div>
                      {kontaktDrustvo.ime ? kontaktDrustvo.ime : null}{" "}
                      {kontaktDrustvo.prezime ? kontaktDrustvo.prezime : null}
                    </div>
                    <div>
                      {kontaktDrustvo.telefon ? (
                        <>
                          <b>telefon: </b>
                          {kontaktDrustvo.telefon}
                        </>
                      ) : null}
                    </div>
                    <div>
                      {kontaktDrustvo.web ? (
                        <>
                          <b>web: </b>
                          {kontaktDrustvo.web}
                        </>
                      ) : null}
                    </div>
                    <div>
                      {kontaktDrustvo.email ? (
                        <>
                          <b>email: </b>
                          {kontaktDrustvo.email}
                        </>
                      ) : null}
                    </div>
                  </td>
                </tr>
              )
            )
          ) : (
            <tr>
              <td colSpan="4"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>
        Ovlašteni revizori koji su zaposleni kod samostalnog revizora ili su s
        njim povezani na drugi način
      </h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Ime i prezime</th>
            <th scope="col">Registarski broj</th>
            <th scope="col">Detalji</th>
          </tr>
        </thead>
        <tbody>
          {osobaDrustvo.length > 0 ? (
            osobaDrustvo.map((ovlRevizor, index) => (
              <tr key={`osoba-drustvo${index}`}>
                <td>
                  {ovlRevizor.imeOsobe} {ovlRevizor.prezimeOsobe}
                </td>
                <td>{ovlRevizor.regBrojOsobe}</td>
                <td className="ant_batn">
                  <ButtonComponent
                    variant="secondary"
                    onClick={(e) =>
                      props.detaljiSecondaryClicked(
                        "osoba",
                        ovlRevizor.idOsobe,
                        ovlRevizor.vrOsobe,
                        false
                      )
                    }
                  >
                    <ZoomInOutlined />
                  </ButtonComponent>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>Registracija kod nadležnih tijela drugih država članica</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv nadležnog tijela</th>
            <th scope="col">Adresa nadležnog tijela</th>
            <th scope="col">Broj i datum registracije</th>
          </tr>
        </thead>
        <tbody>
          {registracijaUDrugojDrzavi.length > 0 ? (
            registracijaUDrugojDrzavi.map((reg, index) =>
              !reg.brReg &&
              !reg.datReg &&
              !reg.nazTijela &&
              !reg.ulicaKbr &&
              !reg.brPoste &&
              !reg.nazNaselja ? (
                <tr key={`reg-u-drugoj-drzavi$index`}>
                  <td colSpan="3"></td>
                </tr>
              ) : (
                <tr key={`reg-u-drugoj-drzavi$index`}>
                  <td>{reg.nazTijela ? reg.nazTijela : noDataMessage}</td>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Ulica i kbr: </b>
                            {reg.ulicaKbr ? reg.ulicaKbr : noDataMessage}
                          </td>
                        </tr>
                        {reg.brPoste || reg.nazNaselja ? (
                          <tr>
                            <td className="inner-td">
                              <b>Grad: </b>
                              {reg.brPoste}
                              {reg.nazNaselja && " " + reg.nazNaselja}
                            </td>
                          </tr>
                        ) : null}
                        {reg.nazivDrzave ? (
                          <tr>
                            <td className="inner-td">
                              <b>Država: </b>
                              {reg.nazivDrzave}
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </td>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Broj registracije: </b>
                            {reg.brReg ? reg.brReg : noDataMessage}
                          </td>
                        </tr>
                        <tr>
                          <td className="inner-td">
                            <b>Datum registracije: </b>
                            {reg.datReg ? reg.datReg : noDataMessage}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              )
            )
          ) : (
            <tr>
              <td colSpan="3"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>
        Registracija u drugoj državi članici kao subjekta za obavljanje revizije
        u trećoj zemlji
      </h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv nadležnog tijela</th>
            <th scope="col">Adresa nadležnog tijela</th>
            <th scope="col">Broj i datum registracije</th>
          </tr>
        </thead>
        <tbody>
          {registracijaZaTreceZemlje.length > 0 ? (
            registracijaZaTreceZemlje.map((reg, index) =>
              !reg.brReg &&
              !reg.datReg &&
              !reg.nazTijela &&
              !reg.ulicaKbr &&
              !reg.brPoste &&
              !reg.nazNaselja ? (
                <tr key={`registracija-treca-zemlja$index`}>
                  <td colSpan="3"></td>
                </tr>
              ) : (
                <tr key={`registracija-treca-zemlja$index`}>
                  <td>{reg.nazTijela ? reg.nazTijela : noDataMessage}</td>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Ulica i kbr: </b>
                            {reg.ulicaKbr ? reg.ulicaKbr : noDataMessage}
                          </td>
                        </tr>
                        {reg.brPoste || reg.nazNaselja ? (
                          <tr>
                            <td className="inner-td">
                              <b>Grad: </b>
                              {reg.brPoste}
                              {reg.nazNaselja && " " + reg.nazNaselja}
                            </td>
                          </tr>
                        ) : null}
                        {reg.nazivDrzave ? (
                          <tr>
                            <td className="inner-td">
                              <b>Država: </b>
                              {reg.nazivDrzave}
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </td>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Broj registracije: </b>
                            {reg.brReg ? reg.brReg : noDataMessage}
                          </td>
                        </tr>
                        <tr>
                          <td className="inner-td">
                            <b>Datum registracije: </b>
                            {reg.datReg ? reg.datReg : noDataMessage}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              )
            )
          ) : (
            <tr>
              <td colSpan="3"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>
        Nadležno tijelo države članice odgovorno za nadzor osiguranja kvalitete
        rada i nadzor ovlaštenih revizora i revizorskih društava
      </h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv nadležnog tijela</th>
            <th scope="col">Adresa nadležnog tijela</th>
          </tr>
        </thead>
        <tbody>
          {tijeloNadleznoZaNadzor.length > 0 ? (
            tijeloNadleznoZaNadzor.map((nadleznoTijelo, index) =>
              !nadleznoTijelo.nazTijela &&
              !nadleznoTijelo.ulicaKbr &&
              !nadleznoTijelo.brPoste &&
              !nadleznoTijelo.nazNaselja ? (
                <tr key={`tijelo-nadlezno-za-nadzor${index}`}>
                  <td colSpan="2"></td>
                </tr>
              ) : (
                <tr key={`tijelo-nadlezno-za-nadzor${index}`}>
                  <td>
                    {nadleznoTijelo.nazTijela
                      ? nadleznoTijelo.nazTijela
                      : noDataMessage}
                  </td>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Ulica i kbr: </b>
                            {nadleznoTijelo.ulicaKbr
                              ? nadleznoTijelo.ulicaKbr
                              : noDataMessage}
                          </td>
                        </tr>
                        {nadleznoTijelo.brPoste || nadleznoTijelo.nazNaselja ? (
                          <tr>
                            <td className="inner-td">
                              <b>Grad: </b>
                              {nadleznoTijelo.brPoste}
                              {nadleznoTijelo.nazNaselja &&
                                " " + nadleznoTijelo.nazNaselja}
                            </td>
                          </tr>
                        ) : null}
                        {nadleznoTijelo.nazivDrzave ? (
                          <tr>
                            <td className="inner-td">
                              <b>Država: </b>
                              {nadleznoTijelo.nazivDrzave}
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </td>
                </tr>
              )
            )
          ) : (
            <tr>
              <td colSpan="2"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>Izrečene odluke i nadzorne mjere</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Vrsta mjere</th>
            <th scope="col">Rješenje</th>
            <th scope="col">Broj i datum rješenja</th>
            {checkIfUserIsAdmin ? (
              <th scope="col">Datum dostave rješenja subjektu</th>
            ) : null}
            {/* <th scope="col">Napomena</th> */}
            <th scope="col">Upravni spor</th>
            <th scope="col">Datum pravomoćnosti</th>
            <th scope="col">Prekršajni postupak</th>
            {checkIfUserIsAdmin || userRole === "ROLE_KORISNIK" ? (
              <th scope="col">Datum brisanja</th>
            ) : null}
          </tr>
        </thead>
        <tbody>
          {mjere.length ? (
            mjere.map((mjera, index) => (
              <tr key={`mjere${index}`}>
                <td>{mjera.vrstaMjere ? mjera.vrstaMjere : noDataMessage}</td>
                <td className="ikona_dokument_td ant_batn">
                  <ButtonComponent
                    className="ikona_dokument"
                    variant="secondary"
                    onClick={(e) =>
                      props.downloadDocumentDrustvo(e, mjera.idMjereDrustva)
                    }
                  >
                    <PaperClipOutlined />
                  </ButtonComponent>

                  <table>
                    <tbody>
                      {mjera.napomena ? (
                        <tr>
                          <td className="inner-td">
                            <b>Napomena: </b>
                            {mjera.napomena}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <td className="inner-td">
                          <b>Broj rješenja: </b>
                          {mjera.brRjesenja ? mjera.brRjesenja : noDataMessage}
                        </td>
                      </tr>
                      <tr>
                        <td className="inner-td">
                          <b>Datum rješenja: </b>
                          {mjera.datRjesenja
                            ? mjera.datRjesenja
                            : noDataMessage}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                {checkIfUserIsAdmin ? (
                  <td>
                    {mjera.datPreuzimanja
                      ? mjera.datPreuzimanja
                      : noDataMessage}
                  </td>
                ) : null}
                <td className="ikona_dokument_td ant_batn">
                  <ButtonComponent
                    className="ikona_dokument"
                    variant="secondary"
                    onClick={(e) =>
                      props.downloadDocumentUSDrustvo(e, mjera.idMjereDrustva)
                    }
                    disabled={mjera.nazivDok2 ? false : true}
                  >
                    <PaperClipOutlined />
                  </ButtonComponent>
                  <table>
                    <tbody>
                      {mjera.napomena2 ? (
                        <tr>
                          <td className="inner-td">
                            <b>Napomena: </b>
                            {mjera.napomena2}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
                <td>
                  {mjera.datPravomocnosti
                    ? mjera.datPravomocnosti
                    : noDataMessage}
                </td>
                <td className="ikona_dokument_td ant_batn">
                  <ButtonComponent
                    className="ikona_dokument"
                    variant="secondary"
                    onClick={(e) =>
                      props.downloadDocumentPPDrustvo(e, mjera.idMjereDrustva)
                    }
                    disabled={mjera.nazivDok3 ? false : true}
                  >
                    <PaperClipOutlined />
                  </ButtonComponent>
                  <table>
                    <tbody>
                      {mjera.napomena3 ? (
                        <tr>
                          <td className="inner-td">
                            <b>Napomena: </b>
                            {mjera.napomena3}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
                {checkIfUserIsAdmin || userRole === "ROLE_KORISNIK" ? (
                  <td>
                    {mjera.datBrisanja ? mjera.datBrisanja : noDataMessage}
                  </td>
                ) : null}
              </tr>
            ))
          ) : (
            <tr key={`mjere`}>
              <td colSpan="8"></td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default ovlRevizorDetaljiTable;
